module.exports = __webpack_public_path__ + "img/45 Puck.d0257380.png";